import { render, staticRenderFns } from "./CustomersTotalizer.vue?vue&type=template&id=7bb57120"
import script from "./CustomersTotalizer.vue?vue&type=script&lang=js"
export * from "./CustomersTotalizer.vue?vue&type=script&lang=js"
import style0 from "./CustomersTotalizer.vue?vue&type=style&index=0&id=7bb57120&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports